var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoOsaLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.33 45.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#412878;}.cls-2{fill:#fff;}.cls-3{fill:#eb962d;}.cls-4{fill:#5ab455;}.cls-5{fill:#c8194b;}.cls-6{fill:#7d82b4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.69,35.66l-.1-29.61H49.53v21a7,7,0,0,1-7,7H10.8V7a7.45,7.45,0,0,1,.07-1H8.48l.1,29.61C5.72,38.86,2.86,42,0,45.2c20.11-.07,40.22.07,60.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.8,34.06H42.53a7,7,0,0,0,7-7V0H17.8a7,7,0,0,0-6.93,6.05,7.45,7.45,0,0,0-.07,1ZM18.54,1.24H48.29V26.32a6.51,6.51,0,0,1-6.5,6.5H12V7.74a6.33,6.33,0,0,1,.24-1.69A6.49,6.49,0,0,1,18.54,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.29,26.32V2.24H18.54A5.51,5.51,0,0,0,13,7.74V31.82H41.79A5.51,5.51,0,0,0,47.29,26.32ZM29.17,22.15a5.07,5.07,0,0,1-5.07,5.07H19.88V23A5.07,5.07,0,0,1,25,17.93h4.22Zm-4.64-6a4.65,4.65,0,1,1,4.64-4.64A4.65,4.65,0,0,1,24.53,16.13Zm15.73,6.44a4.65,4.65,0,1,1-9.29,0h0a4.65,4.65,0,0,1,9.29,0Zm0-11.51a5.07,5.07,0,0,1-5.07,5.07H31V11.91A5.07,5.07,0,0,1,36,6.84h4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,32.82H41.79a6.51,6.51,0,0,0,6.5-6.5V1.24H18.54a6.49,6.49,0,0,0-6.26,4.81A6.33,6.33,0,0,0,12,7.74ZM13,7.74a5.51,5.51,0,0,1,5.5-5.5H47.29V26.32a5.51,5.51,0,0,1-5.5,5.5H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.53,6.84a4.65,4.65,0,1,0,4.64,4.65A4.65,4.65,0,0,0,24.53,6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.88,23v4.23H24.1a5.07,5.07,0,0,0,5.07-5.07V17.93H25A5.07,5.07,0,0,0,19.88,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31,11.91v4.22h4.22a5.07,5.07,0,0,0,5.07-5.07V6.84H36A5.07,5.07,0,0,0,31,11.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.61,17.93A4.64,4.64,0,0,0,31,22.57h0a4.65,4.65,0,1,0,9.29,0h0A4.65,4.65,0,0,0,35.61,17.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOsaLaptop);
export default __webpack_public_path__ + "static/media/ico-osa-laptop.78b89214b12a367e8c2001a7f50176d6.svg";
export { ForwardRef as ReactComponent };